import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./PartnerList.scss";
import "../../styles/global.scss";
// React Bootstrap components
import { Container, Row, Col } from "react-bootstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
// @ts-ignore
import Cookies from "js-cookie";

import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";

// Components
import PopupTemplate from "../components/PopupTemplate/PopupTemplate";
import { partnerTableColumns } from "../components/TableMUI/TableColumns";
import Sidebar from "../components/sidebar/Sidebar";

// TableMUI components
import TableMUI from "../components/TableMUI/TableMUI";
import {
  DeletePartner,
  GetAllPartners,
  GetPartner,
  RestorePartner,
  SoftDeletePartner,
  AcceptTermsAndConditions,
  getAllPartners,
  softDeletePartner,
  getPartnerByID,
  getAllPartnersForConsultant,
  updatePartner,
  requestForInformation,
  getFilteredPartners,
  getFilteredPartnersForConsultant,
} from "../../API/endpoints/Partner";
import { partnerListData } from "../dtos/partner.dtos";
// import DetailsDisplayModal from "../components/modalForms/DiscoveryManagement/DetailsDisplayModal";
import { GetUserProfile } from "../../API/endpoints/User";
import Navbar from "../components/header/NavBar";
import { CreateActivity } from "../../API/endpoints/Dashboard";
import { MarkTodoDone } from "../../API/endpoints/Todos";
import PartnerAgreement from "../components/modalForms/partnerAgreement/PartnerAgreement";
import {
  GetPermissionsByRoleAndModuleID,
  GetRoleById,
} from "../../API/endpoints/RolesAndPermissions/Roles";
import { GetAssignedOrgsForUser } from "../../API/endpoints/RolesAndPermissions/AssignTeam";
import AdvancedFilter from "./AdvancedFilter";
import PartnerManageFiles from "./PartnerManageFiles";
import {
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import ConfirmModal from "../components/Modal/ConfirmModal";
import ToastMessage from "../components/toasts/ToastMessage";
import { useForm } from "react-hook-form";
import { PopupModal, useCalendlyEventListener } from "react-calendly";
import { CreatePartnerUser } from "../../API/endpoints/Partner";
import AssignConsultantModal from "./AssignConsultantModal";
import PartnerUploadFiles from "./PartnerUploadFiles";

function PartnerList() {
  const navigate = useNavigate();
  const routeToForm = () => {
    navigate("/addpartner");
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      docName: "",
      description: "",
    },
  });

  const [data, setData] = useState<any>([]);
  const [flag, setFlag] = useState(false);
  const [showDeletePartner, setShowDeletePartner] = useState(false);
  const [partnerID, setPartnerID] = useState<string | undefined>("");
  const [consultantID, setConsultantID] = useState<string | undefined>("");
  const [partnerName, setPartnerName] = useState<string>("");
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [isPartner, setIsPartner] = useState(false);
  const [dataCount, setDataCount] = useState(0);
  const [listPage, setListPage] = useState(0);
  const [searchParam, setSearchParam] = useState<string>("");
  const [userID, setUserID] = useState<string | undefined>("");
  const [userProfile, setUserProfile] = useState<any>({});
  const [popupType, setPopupType] = useState<string>("");
  const [popupHeader, setPopupHeader] = useState<string>("");
  const [popupMessage, setPopupMessage] = useState<string>("");
  const [partnerAgreementPopup, setPartnerAgreementPopup] =
    useState<boolean>(false);
  const [submitting, setSubmitting] = useState(false);
  const [agreementPartnerId, setAgreementPartnerId] = useState<string>("");
  const [agreementPartnerName, setAgreementPartnerName] = useState<string>("");
  const [roleID, setRoleID] = useState<number>(0);
  const [permissions, setPermissions] = useState<any[]>([]);
  const [dataRestriction, setDataRestriction] = useState(false);
  const [restrictedData, setRestrictedData] = useState<any>([]);
  const [isOpenManageFiles, setIsOpenMangeFiles] = useState<any>("");
  const [isOpenUploadFiles, setIsOpenUploadFiles] = useState<any>("");
  const [approvePartnerModal, setApprovePartnerModal] = useState<any>("");
  const [reload, setReload] = useState(false);
  const [notification, setNotification] = useState({ type: "", msg: "" });
  const [filterReq, setFilterReq] = useState<any>({});

  const [inforReq, setInforReq] = useState<any>("");
  const [inforReqList, setInforReqList] = useState<any[]>([]);

  const handleCloseInfoReq = () => {
    setInforReq("");
    setInforReqList([]);
  };

  const [openRequestCallModal, setOpenRequestCallModal] = useState<any>("");
  const [openCalendlyModal, setOpenCalendlyModal] = useState(false);
  const [openInvitePartnerPOC, setOpenInvitePartnerPOC] = useState(false);
  const [partnerPocData, setPartnerPocData] = useState({} as any);
  const [calendlyPrefill, setCalendlyPrefill] = useState({
    email: "",
    name: "",
    id: "",
  });

  const [assignConsultantModal, setAssignConsultantModal] = useState<
    string | undefined
  >("");
  const [assignConsultants, setAssignConsultants] = useState<any[]>([]);
  const closeRequestCallModal = () => {
    setOpenRequestCallModal(false);
  };

  const closeApprovePartnerModal = () => {
    setApprovePartnerModal("");
  };

  const handleCloseAssign = () => {
    setAssignConsultantModal("");
    setAssignConsultants([]);
  };

  useCalendlyEventListener({
    onEventScheduled: (e) => updateCalendlyStatus(),
  });

  let rows: {
    id: string;
    partnername: string;
    countryoforigin: string;
    partnertype: string;
    serviceCategory: string;
    status: string;
    is_deleted: boolean;
    agreement_status: string;
  }[] = [];

  const handleClose = () => {
    setShowDeletePartner(false);
    setPopupHeader("");
    setPopupMessage("");
  };

  const deleteFunction = async () => {
    setFlag(false);
    await softDeletePartner(partnerID);
    const activity = await CreateActivity(
      `Partner: ${partnerName} deleted temporarily.`
    );
    console.log(activity);
    setFlag(true);
  };

  const restoreFunction = async () => {
    setFlag(false);
    await RestorePartner(partnerID);
    const activity = await CreateActivity(`Partner: ${partnerName} restored.`);
    console.log(activity);
    setFlag(true);
  };

  const premanentDeleteFunction = async () => {
    DeletePartner(partnerID).then(() => {
      setFlag(true);
    });
    const activity = await CreateActivity(
      `Partner: ${partnerName} deleted permanently.`
    );
    console.log(activity);
    setFlag((prev: any) => !prev);
  };

  useEffect(() => {
    setUserID(Cookies.get("userID"));
  }, []);

  useEffect(() => {
    if (userID) {
      (async () => {
        const response = await GetUserProfile(userID);
        if (response?.data) {
          setRoleID(response.data?.user_roles[0]?.roles.id);
          setPartnerID(response.data?.partnerv2_id);
          setUserProfile(response?.data);
          if (response?.data?.user_type === "consultant") {
            setConsultantID(response?.data?.id);
          }
        }
      })();
    }
  }, [userID, navigate]);

  useEffect(() => {
    if (roleID) {
      (async () => {
        const roleDetails = await GetRoleById(roleID.toString());
        setDataRestriction(roleDetails?.data?.data_restriction);

        if (roleDetails?.data?.type === "partner") {
          setIsPartner(true);
          const response = await GetPermissionsByRoleAndModuleID(
            roleID.toString(),
            "12"
          );
          console.log(response);
          setPermissions(response?.data);
        } else if (roleDetails?.data?.type === "administrative") {
          const response = await GetPermissionsByRoleAndModuleID(
            roleID.toString(),
            "4"
          );
          console.log(response);
          setPermissions(response?.data);
        }
      })();
    }
  }, [roleID]);

  useEffect(() => {
    if (permissions[0]?.permission_type.toString() === "1") {
      setIsSuperAdmin(true);
    }
  }, [permissions]);

  useEffect(() => {
    if (dataRestriction && userProfile.user_type !== "consultant") {
      (async () => {
        try {
          const response = await GetAssignedOrgsForUser(
            "partner",
            userID || "",
            listPage,
            searchParam
          );
          setRestrictedData(response?.data?.rows);
          setDataCount(response?.data?.rows?.length);
        } catch (error) {}
      })();
    } else {
      if (isSuperAdmin) {
        (async () => {
          const res =
            userProfile?.user_type === "consultant"
              ? Object.keys(filterReq).length > 0
                ? await getFilteredPartnersForConsultant(
                    userProfile?.id,
                    filterReq,
                    listPage,
                    searchParam
                  )
                : await getAllPartnersForConsultant(
                    userProfile?.id,
                    listPage,
                    searchParam
                  )
              : Object.keys(filterReq).length > 0
              ? await getFilteredPartners(filterReq, listPage, searchParam)
              : await getAllPartners(listPage, searchParam);
          setData(res.data);
          setDataCount(res.data.count);
        })();
      } else {
        if (partnerID) {
          (async () => {
            // const res = await GetPartner(partnerID);
            const res = await getPartnerByID(partnerID);
            setData(res.data);
            setDataCount(1);
          })();
        }
      }
    }
  }, [
    flag,
    isSuperAdmin,
    listPage,
    partnerID,
    searchParam,
    dataRestriction,
    userID,
    userProfile,
    reload,
    filterReq,
  ]);

  useEffect(() => {
    setPartnerName(
      data?.rows?.filter((partner: any) => {
        return partner.id === partnerID;
      })[0]?.name
    );
  }, [popupType, partnerID, showDeletePartner, data]);

  useEffect(() => {
    if (popupType === "restore") {
      setPopupHeader("Confirm Restore");
      setPopupMessage(
        "Are you sure you want to restore partner: " + partnerName + "?"
      );
    } else if (popupType === "delete") {
      setPopupHeader("Confirm Deletion");
      setPopupMessage(
        "Are you sure you want to delete partner: " + partnerName + "?"
      );
    } else if (popupType === "delete-permanently") {
      setPopupHeader("Confirm Deletion");
      setPopupMessage(
        "Are you sure you want to permanently delete partner: " +
          partnerName +
          "?"
      );
    }
  }, [popupType, partnerName]);

  if (
    permissions[0]?.sub_modules[4]?.permissions_actions[1]?.permission[0]
      ?.permission === true
  ) {
    if (data?.rows && isSuperAdmin) {
      rows = data?.rows?.map((dataItem: partnerListData) => ({
        id: dataItem.id,
        partnername: dataItem?.name || "NA",
        partneremail: dataItem?.poc_email || "NA",
        countryoforigin: dataItem.region.name || "NA",
        partnertype: dataItem?.partnertype?.name || "NA",
        createdBy: dataItem?.user?.first_name
          ? dataItem?.user?.first_name + " " + dataItem?.user?.last_name
          : "NA",
        // serviceCategory: dataItem?.partner_categories[0]?.categories?.name
        //   ? dataItem?.partner_categories[0]?.categories?.name
        //   : "NA",
        serviceCategory: "NA",
        status: dataItem.status || "NA",
        poc_firstname: dataItem.poc_firstname || "NA",
        poc_lastname: dataItem.poc_lastname || "NA",
        poc_phone: dataItem.poc_phone || "NA",
        poc_countrycode: dataItem.poc_countrycode || "NA",
        poc_designation: dataItem.poc_designation || "NA",
        is_deleted: dataItem.is_deleted,
        agreement_status: dataItem.status,
        user_partners: dataItem?.user_partners ? dataItem.user_partners : [],
      }));
    } else if (data?.id && isPartner) {
      rows = [
        {
          id: data?.id,
          partnername: data?.company_name,
          countryoforigin: data?.region.name,
          partnertype: data?.partnertype?.name,
          serviceCategory: data?.partner_categories
            ? data?.partner_categories[0]?.categories?.name
            : "NA",
          status: data?.status,
          is_deleted: data?.is_deleted,
          agreement_status: data?.status,
        },
      ];
    } else if (restrictedData.length !== 0) {
      rows = restrictedData.map((dataItem: any) => ({
        id: dataItem.partner.id,
        partnername: dataItem.partner.company_name || "NA",
        countryoforigin: dataItem.partner.region.name || "NA",
        partnertype: dataItem?.partner.partnertype?.name || "NA",
        serviceCategory: dataItem?.partner.partner_categories[0]?.categories
          ?.name
          ? dataItem?.partner.partner_categories[0]?.categories?.name
          : "NA",
        status: dataItem.partner.status || "NA",
        is_deleted: dataItem.partner.is_deleted,
        agreement_status: dataItem.partner.status,
      }));
    }
  }

  const columns = partnerTableColumns(
    setPartnerID,
    setShowDeletePartner,
    navigate,
    data,
    // setSelectedPartnerID,
    // setShowDetailsModal,
    setPopupType,
    permissions,
    userProfile,
    setIsOpenMangeFiles,
    setIsOpenUploadFiles,
    setOpenRequestCallModal,
    setOpenCalendlyModal,
    setCalendlyPrefill,
    setApprovePartnerModal,
    setInforReq,
    setOpenInvitePartnerPOC,
    setPartnerPocData,
    setAssignConsultantModal,
    setAssignConsultants
  );

  const handleOnFilter = (req: any) => {
    setListPage(0);
    setFilterReq(req);
  };

  const handleClearFilter = () => {
    setListPage(0);
    setFilterReq({});
  };

  const handleCloseAgreementPopup = () => {
    setPartnerAgreementPopup(false);
    setAgreementPartnerId("");
    setAgreementPartnerName("");
  };

  const handleCloseNotification = () => {
    setNotification({
      type: "",
      msg: "",
    });
  };

  const handleSaveInfoReq = () => {
    if (inforReqList.length) {
      inforReqList.forEach((item: any) => {
        const req = { ...item, partner_id: inforReq };
        requestForInformation(req).then((res) => {
          updateRequestForCall(inforReq);
        });
      });
    } else {
      setNotification({
        type: "error",
        msg: "Add at least one information request",
      });
    }

    // const partnerData: any = rows.find((p: any) => p.id === inforReq);
    // if (partnerData?.user_partners && partnerData?.user_partners?.length > 0) {
    //   inforReqList.forEach((item: any) => {
    //     partnerData?.user_partners?.forEach((c: any) => {
    //       const req = {
    //         ...item,
    //         partner_id: inforReq,
    //         consultant_id: c?.user_id,
    //       };
    //       requestForInformation(req).then((res) => {
    //         updateRequestForCall(inforReq);
    //       });
    //     });
    //   });
    // } else {
    //   setNotification({
    //     type: "error",
    //     msg: "No consultant assigned",
    //   });
    // }
  };

  const updateRequestForCall = (inforReq: any) => {
    console.log(inforReq, "inforReq");
    const reqData = {
      status: "INFORMATION_REQUESTED",
    };

    updatePartner(reqData, inforReq)
      .then((res) => {
        setInforReq("");
        setInforReqList([]);
        setReload(!reload);
        setNotification({
          type: "success",
          msg: "Information requested successfully",
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const onAgreementSubmit = async (partnerId: string, partnerName: string) => {
    try {
      setSubmitting(true);
      await AcceptTermsAndConditions(partnerId);
      setPartnerAgreementPopup(false);
      setSubmitting(false);
      setAgreementPartnerId("");
      setAgreementPartnerName("");
      setFlag(true);
      await CreateActivity(
        `Partner ${partnerName} accepted the agreement and is active.`
      );
      try {
        const todoDone = await MarkTodoDone(`partnerKeyTerms:${partnerId}`);
      } catch (ex: any) {
        console.log(ex);
      }
      setFlag(false);
      Cookies.set("IsActivated", "true");
    } catch (error) {
      setSubmitting(false);
    }
  };

  const openRequestCall = () => {
    setOpenRequestCallModal(true);
  };

  const updateCalendlyStatus = () => {
    const reqData = {
      status: "CALL_SCHEDULED",
    };

    updatePartner(reqData, calendlyPrefill?.id)
      .then((res) => {
        setNotification({
          type: "success",
          msg: "Call Scheduled successfully",
        });
        setReload(!reload);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const onApprovePartner = async () => {
    const reqData = {
      status: "APPROVED",
    };

    updatePartner(reqData, approvePartnerModal)
      .then((res) => {
        setNotification({
          type: "success",
          msg: "Partner Approved successfully",
        });
        setReload(!reload);
      })
      .catch((err) => {
        console.log("err", err);
      });

    closeApprovePartnerModal();
  };

  const onInvitePoc = async (id: string) => {
    const reqData = {
      status: "INVITED",
    };

    updatePartner(reqData, id)
      .then((res) => {
        setNotification({
          type: "success",
          msg: "Partner Invited successfully",
        });
        setReload(!reload);
      })
      .catch((err) => {
        console.log("err", err);
      });

    closeApprovePartnerModal();
  };

  const onConfirmCallRequest = () => {
    const reqData = {
      status: "CALL_REQUESTED",
    };

    updatePartner(reqData, openRequestCallModal)
      .then((res) => {
        setNotification({
          type: "success",
          msg: "Call Requested successfully",
        });
        closeRequestCallModal();
        setReload(!reload);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const onConfirmInvitePartner = () => {
    (async () => {
      try {
        let pocMember: any = {
          first_name: partnerPocData?.poc_firstname,
          last_name: partnerPocData?.poc_lastname,
          designation: partnerPocData?.poc_designation,
          email_id: partnerPocData?.partneremail,
          contact_number: partnerPocData?.poc_phone,
          contact_number_code: "+91",
          user_type: "partner",
          partner_id: partnerPocData?.id,
          role: [5],
        };
        await CreatePartnerUser(pocMember);
        onInvitePoc(partnerPocData?.id);
        setOpenInvitePartnerPOC(false);
      } catch (err) {
        console.error(err);
        setNotification({ type: "error", msg: err as string });
        setOpenInvitePartnerPOC(false);
      }
    })();
  };

  const onSubmitInfoReq = (data: any) => {
    setInforReqList([...inforReqList, data]);
    reset();
  };

  const handleRemoveReqInfoItem = (index: any) => {
    const data = [...inforReqList];
    data.splice(index, 1);
    setInforReqList([...data]);
  };

  const onSuccessUpload = () => {
    setFlag(!flag);
    setNotification({
      type: "success",
      msg: "Information submitted successfully",
    });
  };

  const infoReqs = inforReqList.map((item, key) => {
    return (
      <Row className="mb16px mx-1" key={key}>
        <Col sm={3} lg={3} xl={3}>
          <Typography
            sx={{ textAlign: "left", color: "#1D2939", fontSize: "14px" }}
          >
            {item?.docName}
          </Typography>
        </Col>
        <Col sm={8} lg={8} xl={8}>
          <Typography
            sx={{ textAlign: "left", color: "#475467", fontSize: "12px" }}
          >
            {item?.description}
          </Typography>
        </Col>
        <Col sm={1} lg={1} xl={1}>
          <Button
            style={{
              minWidth: "40px",
              maxWidth: "40px",
              padding: "0",
              maxHeight: "40px",
              textAlign: "center",
              lineHeight: "20px",
            }}
            onClick={() => handleRemoveReqInfoItem(key)}
            className="badgepill-blue50  blue-text br-0 bold no-border align-center"
          >
            <img
              width="20px"
              className="listicon"
              src="../svgs/delete.svg"
              alt="Singapore"
            />
          </Button>
        </Col>
      </Row>
    );
  });

  return (
    <Container fluid className="adminusers">
      <Row className="row">
        <Col className="sidebar">
          <Sidebar active="partner" />
        </Col>
        <Col className="adminusers-content p-0">
          <Navbar userProfile={userProfile} />
          <Breadcrumb className="font12-medium breadcrumb-nav">
            <Breadcrumb.Item active>
              <Link to="/PartnerManagement">PARTNER MANAGEMENT</Link>{" "}
            </Breadcrumb.Item>
          </Breadcrumb>
          <div className="action-panel">
            <InputGroup size="sm" className="input-search">
              <InputGroup.Text id="inputGroup-sizing-sm">
                <img src="../svgs/lenseicon.svg" alt="searchicon" />
              </InputGroup.Text>
              <Form.Control
                aria-label="Small"
                aria-describedby="inputGroup-sizing-sm"
                placeholder="Search"
                onChange={(e) => {
                  setSearchParam(e.target.value);
                }}
              />
            </InputGroup>
            <AdvancedFilter
              onFilter={handleOnFilter}
              onClearFilter={handleClearFilter}
            />
            {/* <PartnerManageFiles /> */}
            {permissions[0]?.sub_modules[0]?.permissions_actions[0]
              ?.permission[0]?.permission === true &&
              permissions[0]?.sub_modules[0]?.permissions_actions[1]
                ?.permission[0]?.permission === true &&
              permissions[0]?.sub_modules[4]?.permissions_actions[0]
                ?.permission[0]?.permission === true && (
                <Button
                  onClick={routeToForm}
                  className="btn-primary12 !bg-[#24a0ed] adduser"
                >
                  Add New Partner
                </Button>
              )}
          </div>

          <div className="adminusertable">
            <div className="TableMUIcountainer">
              <TableMUI
                columns={columns}
                rows={rows}
                dataCount={dataCount}
                setListPage={setListPage}
                listPage={listPage}
              />
            </div>
            <PopupTemplate
              popupHeader={popupHeader}
              popupBody={popupMessage}
              handleFunction={
                popupType === "restore"
                  ? restoreFunction
                  : popupType === "delete"
                  ? deleteFunction
                  : premanentDeleteFunction
              }
              isModalOpen={showDeletePartner}
              onCancel={handleClose}
              id={partnerID}
              setFlag={setFlag}
              isRestore={popupType === "restore" ? true : false}
            />
            {/* <DetailsDisplayModal
              isModalOpen={showDetailsModal}
              onCancel={handleCloseDetailsModal}
              userType={"PartnerList"}
              selectedRequestBrandID={selectedPartnerID}
              publicFiles={[]}
            /> */}
            <PartnerManageFiles
              setIsOpen={setIsOpenMangeFiles}
              isOpen={isOpenManageFiles}
            />
            <PartnerUploadFiles
              setIsOpen={setIsOpenUploadFiles}
              isOpen={isOpenUploadFiles}
              consultantID={consultantID}
              onSuccess={onSuccessUpload}
            />
            <PartnerAgreement
              isModalOpen={partnerAgreementPopup}
              onCancel={handleCloseAgreementPopup}
              partnerID={agreementPartnerId}
              partnerName={agreementPartnerName}
              submitting={submitting}
              onSubmit={onAgreementSubmit}
            />
          </div>
        </Col>
      </Row>

      <Dialog
        className="modal_700"
        open={Boolean(inforReq)}
        onClose={handleCloseInfoReq}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Request For More Information"}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseInfoReq}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Card
            sx={{
              boxShadow: "none",
              border: "1px solid #EEEAF5",
            }}
          >
            <Row
              sx={{
                color: "#344054",
                backgroundColor: "#fcfcfd",
                align: "center",
                lineHeight: "44px",
                textIndent: "12px",
              }}
              className=" font-14 py20 px-2"
            >
              <Col sm={3} lg={3} xl={3}>
                File
              </Col>
              <Col sm={8} lg={8} xl={8}>
                Description
              </Col>
              <Col sm={1} lg={1} xl={1} className="ml-n20">
                Actions
              </Col>
            </Row>
            <Form
              onSubmit={handleSubmit((data) => {
                onSubmitInfoReq(data);
              })}
            >
              <Row className="mb16px mx-1 ">
                <Col sm={3} lg={3} xl={3} className="p-03">
                  <Form.Group className="formgroup" controlId="docName">
                    <Form.Control
                      type="text"
                      placeholder="File Name"
                      {...register("docName", {
                        required: "* This field is required",
                      })}
                    />
                    <Form.Text muted>
                      <span>
                        {/* {errors?.first_name && (
                        <p className="error-form">
                          {String(errors.first_name?.message)}
                        </p>
                      )} */}
                      </span>
                    </Form.Text>
                  </Form.Group>
                </Col>
                <Col sm={8} lg={8} xl={8} className="p-03">
                  <Form.Group controlId="">
                    <Form.Control
                      style={{
                        textAlign: "left",
                        color: "#475467",
                        fontSize: "12px",
                      }}
                      as="textarea"
                      rows={3}
                      placeholder="sample text"
                      {...register("description", {
                        required: "* This field is required",
                      })}
                    />
                  </Form.Group>
                </Col>
                <Col sm={1} lg={1} xl={1} className="p-03">
                  <Button
                    style={{
                      minWidth: "40px",
                      maxWidth: "40px",
                      padding: "0",
                      maxHeight: "40px",
                      textAlign: "center",
                      lineHeight: "20px",
                    }}
                    type="submit"
                    className="badgepill-blue50  blue-text br-0 bold no-border align-center"
                  >
                    <AddIcon
                      sx={{
                        fontSize: "19px",
                        fontWeight: "500",
                        alignItems: "center",
                      }}
                    />
                  </Button>
                </Col>
              </Row>
            </Form>
            {infoReqs}
          </Card>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleCloseInfoReq}>
            Cancel
          </Button>
          <Button
            // sx={{ background: "#0152FB", color: "#FFFFFF" }}
            onClick={handleSaveInfoReq}
            autoFocus
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <AssignConsultantModal
        open={Boolean(assignConsultantModal)}
        handleCloseMarket={handleCloseAssign}
        params={{ partnerId: assignConsultantModal }}
        consultantData={assignConsultants}
        reloadData={() => setFlag(!flag)}
      />

      <ConfirmModal
        haveIcon={false}
        isModalOpen={Boolean(approvePartnerModal)}
        submit={onApprovePartner}
        closeModal={closeApprovePartnerModal}
        submitBtnText="Approve"
        cancelBtnText="Cancel"
        title="Confirm Partner Approval"
        bodyText="Are you sure you want to approve this partner ?"
      />
      <ConfirmModal
        haveIcon={false}
        isModalOpen={Boolean(openRequestCallModal)}
        submit={onConfirmCallRequest}
        closeModal={closeRequestCallModal}
        submitBtnText="Confirm"
        cancelBtnText="Cancel"
        title="Confirm Call Request"
        bodyText="Are you sure you want to request for call ?"
      />
      <ConfirmModal
        haveIcon={false}
        isModalOpen={openInvitePartnerPOC}
        submit={onConfirmInvitePartner}
        closeModal={() => setOpenInvitePartnerPOC(false)}
        submitBtnText="Confirm"
        cancelBtnText="Cancel"
        title="Confirm Partner POC Invitation"
        bodyText="Are you sure you want to invite this partner ?"
      />
      <PopupModal
        url="https://calendly.com/aegsg" // *FOR TESTING
        prefill={calendlyPrefill}
        onModalClose={() => setOpenCalendlyModal(false)}
        open={openCalendlyModal}
        rootElement={document.getElementById("root") as HTMLElement}
      />
      <ToastMessage
        notification={notification}
        onCancel={handleCloseNotification}
      />
    </Container>
  );
}
export default PartnerList;
